module.exports = __webpack_public_path__ + "427238f67009808ae296f5af0c6f4e52.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudablack-webfont.woff2
// module id = 1307
// module chunks = 28